import { render } from "./CMemberRequestor.vue?vue&type=template&id=f7add850"
import script from "./CMemberRequestor.vue?vue&type=script&lang=js"
export * from "./CMemberRequestor.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__